// extracted by mini-css-extract-plugin
module.exports = {"callTime":"CallTimer_callTime__3sRx9"};